import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mx-auto grid max-w-[var(--site-max-width)] grid-cols-2 gap-x-4 gap-y-6 tablet:grid-cols-4 desktop:grid-cols-6"
}

import { computed } from 'vue';
import ProductCard from '../ProductCard.vue';

import useGiftCard from '@/composables/useGiftCard';
import { getContext } from '@/composables/useSearch';


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchResult',
  setup(__props) {

const { searchResult } = getContext();
const { activeGiftCard } = useGiftCard();

const products = computed(() => searchResult.value?.products || []);

const showFavoriteProducts = computed(() => (activeGiftCard.value?.giftCards?.length ?? 0) > 0);

function isFavoriteProduct(productId: string) {
  return activeGiftCard.value?.favoriteProductIds?.includes(productId) ?? false;
}

return (_ctx: any,_cache: any) => {
  return (products.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, (product, index) => {
          return (_openBlock(), _createBlock(ProductCard, {
            key: index,
            product: product,
            "is-favorite-product": isFavoriteProduct(product.articleNumber),
            "show-favorite-products": showFavoriteProducts.value
          }, null, 8, ["product", "is-favorite-product", "show-favorite-products"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})